export default __webpack_public_path__ + "static/media/passwort.d6405928.jpg";